<template>
    <div>
        <div class="preTitle" style="color: #5E8F23">{{preTitle}}</div>
          <b-button class="bg-primary plusButton mr-1 px-0 pt-0 pb-0">
                                <div style="color:#D7B92C">
                                    <feather-icon icon="PlusIcon" size="45" />
                               </div>
        </b-button>
    </div>
</template>

<script>
import {BImg, BLink, BButton} from 'bootstrap-vue'
export default {
    props:{
        preTitle:String,
        routeTitle:String,
    },
    components: {
        BImg,
        BLink,
        BButton,
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss">

.plusButton {

    position: absolute;
    top:83%;
    right:1%;
    border-radius:50%;

}

.preTitle {

    position: absolute;
    top:85%;
    right:20%;
    color: #5E8F23;
    font-weight: 600;
    font-size: medium;

}
</style>